"use client";

import { useTranslations } from "next-intl";
import { Card, CardContent, CardHeader, CardTitle } from "@ui/components/card";
import { Skeleton } from "@ui/components/skeleton";

interface AnalyticsLoadingStateProps {
  title?: string;
  showTabs?: boolean;
}

export function AnalyticsLoadingState({ 
  title,
  showTabs = true 
}: AnalyticsLoadingStateProps) {
  const t = useTranslations();

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>{title || t("properties.analytics.title")}</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
            {[1, 2, 3, 4].map((i) => (
              <Card key={i}>
                <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                  <Skeleton className="h-4 w-24" />
                </CardHeader>
                <CardContent>
                  <Skeleton className="h-8 w-16" />
                </CardContent>
              </Card>
            ))}
          </div>
        </CardContent>
      </Card>
      {showTabs && (
        <>
          <Skeleton className="h-8 w-full" />
          <Skeleton className="h-64 w-full" />
        </>
      )}
    </div>
  );
} 